export default __webpack_public_path__ + "static/media/cartoon_tree_no_bg.9d775935.png";